import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IResponseInstanceTypeByResourceType,
} from '@toolify/server/src/services/ResourceService/types/IResponseInstanceTypeByResourceType'
import {mapWorkspaceResponseInstance} from '@toolify/client/src/modules/api/singletons/mapWorkspaceResponseInstance'
import {
  IWorkspaceResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IWorkspaceResponseInstance'
import {mapDatabaseResponseInstance} from '@toolify/client/src/modules/api/singletons/mapDatabaseResponseInstance'
import {
  IDatabaseResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabaseResponseInstance'
import {
  mapDatabasePropertyResponseInstance,
} from '@toolify/client/src/modules/api/singletons/mapDatabasePropertyResponseInstance'
import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {mapDatabaseViewResponseInstance} from '@toolify/client/src/modules/api/singletons/mapDatabaseViewResponseInstance'
import {
  IDatabaseViewResponseInstance,
} from '@toolify/server/src/controllers/DatabaseViewController/types/IDatabaseViewResponseInstance'
import {mapDatabaseItemResponseInstance} from '@toolify/client/src/modules/api/singletons/mapDatabaseItemResponseInstance'
import {
  IDatabaseItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/types/IDatabaseItemResponseInstance'
import {mapConversationResponseInstance} from './mapConversationResponseInstance'
import {IConversationResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IConversationResponseInstance'

export function mapResourceByType<T extends ResourceType>(
  resourceType: T,
  resource: IToJson<IResponseInstanceTypeByResourceType[T]>,
): IResponseInstanceTypeByResourceType[T] {
  switch(resourceType) {
  case ResourceType.Workspace:
    return mapWorkspaceResponseInstance(resource as IToJson<IWorkspaceResponseInstance>) as IResponseInstanceTypeByResourceType[T]
  case ResourceType.Conversation:
    return mapConversationResponseInstance(resource as IToJson<IConversationResponseInstance>) as IResponseInstanceTypeByResourceType[T]
  case ResourceType.Database:
    return mapDatabaseResponseInstance(resource as IToJson<IDatabaseResponseInstance>) as IResponseInstanceTypeByResourceType[T]
  case ResourceType.DatabaseProperty:
    return mapDatabasePropertyResponseInstance(resource as IToJson<IDatabasePropertyResponseInstance>) as IResponseInstanceTypeByResourceType[T]
  case ResourceType.DatabaseView:
    return mapDatabaseViewResponseInstance(resource as IToJson<IDatabaseViewResponseInstance>) as IResponseInstanceTypeByResourceType[T]
  case ResourceType.DatabaseItem:
    return mapDatabaseItemResponseInstance(resource as IToJson<IDatabaseItemResponseInstance>) as IResponseInstanceTypeByResourceType[T]
  }
}
